import React from 'react'
import { TAG_CLICK_POI_FICHE_ADDRESSE } from '../../store/analytics/analytics.actionTypes'
import NavButton from '../router/NavButton'
import { ROUTE_SEO_GEOENTITY } from '../../routes'
import { generateFullRoute } from '../router/routeUtils'
import { useSelector } from 'react-redux'
import { selectNavigateToGeoentityParameters } from '../../store/history/history.navigate.selectors'

export default function GoToGeoentityButton({ children, poi, className, isLink = false, hasItemScope }) {
  const navigateToParams = useSelector(store => selectNavigateToGeoentityParameters(store, { id: poi.id }))
  const extraProps = hasItemScope
    ? {
        itemProp: 'url',
        hasItemScope
      }
    : {}
  return (
    <NavButton
      href={isLink ? generateFullRoute(ROUTE_SEO_GEOENTITY, { geoentityId: poi.id }) : ''}
      to={navigateToParams}
      tagData={{
        type: TAG_CLICK_POI_FICHE_ADDRESSE,
        tagInfo: {
          appId: poi.tabs?.[0]?.appId,
          catId: poi?.rubric?.id
        }
      }}
      className={className}
      {...extraProps}
    >
      {children}
    </NavButton>
  )
}
